var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('massive-file-loader',{attrs:{"parser":_vm.parser},on:{"loaded":function($event){return _vm.$emit('loaded', $event)},"loading":function($event){return _vm.$emit('loading')},"error":function($event){return _vm.$emit('error')}}})}
var staticRenderFns = []

export { render, staticRenderFns }